var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWakeupMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#4FAADB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11508_15924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7001 6.25C11.7001 5.55859 12.2586 5 12.9501 5H16.7001C17.1727 5 17.6063 5.26953 17.8172 5.69141C18.0282 6.11328 17.9852 6.62109 17.7001 7L15.4501 10H16.7001C17.3915 10 17.9501 10.5586 17.9501 11.25C17.9501 11.9414 17.3915 12.5 16.7001 12.5H12.9501C12.4774 12.5 12.0438 12.2305 11.8329 11.8086C11.6219 11.3867 11.6649 10.8789 11.9501 10.5L14.2001 7.5H12.9501C12.2586 7.5 11.7001 6.94141 11.7001 6.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 15C17.5001 14.3086 18.0586 13.75 18.7501 13.75H22.5001C22.9727 13.75 23.4063 14.0195 23.6172 14.4414C23.8282 14.8633 23.7852 15.3711 23.5001 15.75L21.2501 18.75H22.5001C23.1915 18.75 23.7501 19.3086 23.7501 20C23.7501 20.5049 23.4522 20.939 23.0222 21.1364L18.789 17.8647L20.0001 16.25H18.7501C18.0586 16.25 17.5001 15.6914 17.5001 15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7766 14.2L14.209 16.8529L10.168 21.7H13.7501C14.4415 21.7 15.0001 22.2586 15.0001 22.95C15.0001 23.6414 14.4415 24.2 13.7501 24.2H7.50006C7.01568 24.2 6.57427 23.9227 6.36724 23.4813C6.16021 23.0398 6.23052 22.5203 6.53912 22.1492L11.0821 16.7H7.50006C6.80865 16.7 6.25006 16.1414 6.25006 15.45C6.25006 14.7586 6.80865 14.2 7.50006 14.2H10.7766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6118 19.4829L19.8982 21.25H18.7501C18.2774 21.25 17.8438 20.9805 17.6329 20.5586C17.4627 20.2184 17.4578 19.8222 17.6118 19.4829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5792 22.495L5.193 8.2845C4.97519 8.11512 4.93581 7.80106 5.10519 7.58293L5.71895 6.79323C5.88833 6.5751 6.2027 6.53573 6.42083 6.70542L24.807 20.9159C25.0248 21.0853 25.0642 21.3993 24.8948 21.6175L24.281 22.4072C24.1117 22.6253 23.7973 22.6644 23.5792 22.495Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11508_15924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWakeupMap);
export default __webpack_public_path__ + "static/media/wakeup_map.51a7e347394fab207a57774cba69a325.svg";
export { ForwardRef as ReactComponent };